import { createGlobalStyle } from "styled-components";


export default createGlobalStyle`

    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        src: url('./assets/fonts/Poppins-Regular.ttf') format('ttf');
        font-display: swap;
    }

    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        src: url('./assets/fonts/Poppins-Medium.ttf') format('ttf');
        font-display: swap;
    }

    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 600;
        src: url('./assets/fonts/Poppins-SemiBold.ttf') format('ttf');
        font-display: swap;
    }

    @font-face {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        src: url('./assets/fonts/Poppins-Bold.ttf') format('ttf');
        font-display: swap;
    }


    * {
    margin: 0;
    padding: 0;
    box-sizing: border-box
    }

    html,body{
        font-family: 'Poppins', sans-serif;
        font-size: 62.5%;
        width: 100vw;
    }


    button {
        cursor: pointer;
        background: none;
        border: none;
    }

    ul{
        list-style: none;
    }

    a{
        text-decoration: none;
    }
`